var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.limitedFiles)?_c('LimitedFileInput',{ref:"input",attrs:{"label":_vm.label,"files-count":_vm.filesCount}}):_c('MultipleFileInput',{ref:"input",on:{"input":function($event){return _vm.$emit('attachment-change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }